import ReUpload from "js/views/components/ReUpload";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import {
  changeReminderState,
  getDiagnosisByUUID,
  getDoctor,
  removeCaseImage,
  setReminder,
  changeImageVisibility,
} from "js/redux/actions/diagnoses";
import LoaderDiv from "../components/LoaderDiv";
import AccordionItem from "../components/Accordion";
import rateStar from "assets/icons/rate-star.svg";
import bell from "assets/icons/bell.svg";
import deleteIcon from "assets/icons/delete.svg";
import imgUnavailable from "assets/icons/image-unavailable.svg";
import Prescription from "../components/Prescription";
import DownloadFile from "../components/DownloadFile";
import calendar from "assets/icons/calendar.svg";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import UseModal from "../components/useModal";

function Summary({
  consultation,
  getDiagnosisByUUID,
  getDoctor,
  doctors,
  t,
  setReminder,
  removeCaseImage,
  changeImageVisibility,
}) {
  const { consultationId, status } = useParams();

  const [loading, setLoading] = useState(true);
  const [doctor, setDoctor] = useState(null);
  const [accordionIsOpen, setAccordionIsOpen] = useState(false);
  const [isCloseup, setIsCloseup] = useState(1);
  const [Modal, openModal, closeModal] = UseModal();

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      await getDiagnosisByUUID(consultationId);
      setLoading(false);
    })();
  }, [consultationId]);

  useEffect(() => {
    (async () => {
      if (
        consultation &&
        Object.keys(consultation).length > 0 &&
        consultation.diagnosed &&
        (!doctor || Object.keys(doctor).length === 0)
      ) {
        const drUUID =
          consultation.diagnoses[consultation.diagnoses.length - 1]
            .performed_by;
        if (drUUID) {
          await getDoctor(drUUID);
        }
      }
    })();
  }, [consultation, doctor, doctors, getDoctor]);

  useEffect(() => {
    if (doctors && Object.keys(doctors).length > 0) {
      setDoctor(doctors);
    }
  }, [doctors]);

  const feedbackButton = () => {
    if (
      consultation.category === "video" &&
      process.env.REACT_APP_FEEDBACK_VIDEO
    )
      window.open(
        process.env.REACT_APP_FEEDBACK_PICTURE,
        "_blank",
        "noopener,noreferrer",
      );
    else if (
      consultation.category === "picture" &&
      process.env.REACT_APP_FEEDBACK_PICTURE
    )
      window.open(
        `${process.env.REACT_APP_FEEDBACK_PICTURE}${
          consultation.promoUsed
            ? `?mc=${encodeURIComponent(consultation.promoUsed)}`
            : ""
        }`,
        "_blank",
        "noopener,noreferrer",
      );
    else return <></>;
  };

  const getDays = (appointment) => {
    if (appointment) {
      const targetDate = new Date(appointment.booked_to);

      // Current date
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);

      // Calculate the difference in milliseconds
      const timeDifference = targetDate - currentDate;

      // Convert milliseconds to days (rounded down)
      const daysLeft = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      return daysLeft;
    }
  };

  const getDate = (dateInput) => {
    // Parse the input date string
    const dateString = dateInput;
    const date = new Date(dateString);

    // Format the date parts
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "long" });
    const hours = date.getHours();
    const minutes = date.getMinutes();

    // Convert hours to 12-hour format and determine AM/PM
    const period = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12; // Convert 0 to 12 for 12 AM

    // Add leading zero to minutes if needed
    const minutesFormatted = minutes < 10 ? `0${minutes}` : minutes;

    // Create the formatted date string
    const formattedDate = `${day} ${month} at ${hours12}:${minutesFormatted} ${period}`;

    return formattedDate;
  };

  const addReminder = async (id) => {
    if (
      consultation.diagnoses[0].appointment_reminder === 0 ||
      consultation.diagnoses[0].appointment_reminder === false
    ) {
      try {
        await setReminder(id);

        //changeReminderState(result);
        toast.success("Reminder set successfully!");
      } catch (err) {
        toast.error("Error setting reminder");
      }
    }
  };

  const getTagline = (appointment, category, diagnosed, rejected_by) => {
    if (category === "video") {
      if (getDays(appointment) < 0) {
        return (
          <div className="success-tagline">
            <span className="success-tagline-text">
              {t("case_history.your_appointment_completed_on")}{" "}
              <span className="success-tagline-bold">
                {getDate(appointment.booked_to)}{" "}
              </span>{" "}
              .<br /> {t("case_history.any_documents_attached")}
            </span>
            <button
              onClick={() => feedbackButton()}
              className="rate-consultation"
            >
              <img src={rateStar} alt="rate" />
              <span className="rate-consultation-text">
                {t("summary.rate_consultation")}
              </span>
            </button>
          </div>
        );
      } else {
        return (
          <span className="status-tagline">
            {t("case_history.your_appointment_is_booked_for")}{" "}
            <span className="success-tagline-bold">
              {getDate(appointment.booked_to)}.{" "}
            </span>{" "}
            {t("case_history.find_link_in_your_email")}
            {/* Your appointment is booked for <b> 16 April at 09:30 AM.</b> You can
        find the link for the appointment in your email. */}
          </span>
        );
      }
    } else {
      if (diagnosed === 1) {
        return;
      } else if (rejected_by !== null) {
        return <ReUpload message={consultation.reject_reason} />;
      } else {
        return (
          <div className="status-tagline">
            {t("case_history.picture_consultaion_under_assessment_tagline")}
          </div>
        );
      }
    }
  };

  const handleBookNow = () => {
    if (consultation.diagnoses[0].next_appointment_type === "video") {
      window.open(
        "https://staging.booking.skin.drdropin.no/book?flow=video",
        "_blank",
      );
    } else if (consultation.diagnoses[0].next_appointment_type === "clinic") {
      window.open(
        "https://staging.booking.drdropin.no/en?vertical=dermatologist",
        "_blank",
      );
    } else {
      window.open(
        "https://staging.booking.skin.drdropin.no/book?flow=picture",
        "_blank",
      );
    }
  };

  const isLessThan24Hours = (dateString) => {
    const now = moment();
    const givenDate = moment(dateString);
    const diffInHours = Math.abs(now.diff(givenDate, "hours"));
    return diffInHours < 24;
  };

  const hasDatePassed = (dateString) => {
    return moment(dateString).isBefore(moment());
  };

  const deleteImage = async (id) => {
    await removeCaseImage({ id: id });
    changeImageVisibility({ id: id, isCloseup: isCloseup, is_visible: 0 });
    closeModal();
  };

  return loading ? (
    <div className="summary-loader">
      <LoaderDiv />
    </div>
  ) : (
    <div className="summary">
      <ToastContainer />
      <Modal>
        <div className="delete-confirm-box">
          <span className="delete-confirm-text">
            {t("summary.delete_image")}?
          </span>
          <span className="delete-confirm-subtext">
            {t("summary.delete_image_subtext")}
          </span>
          <div className="delete-confirm-btns">
            <button className="cancel-btn" onClick={() => closeModal()}>
              {t("summary.cancel")}
            </button>
            <button
              className="delete-btn"
              onClick={() => {
                if (isCloseup) {
                  deleteImage(consultation.closeupImages[0].uuid);
                } else {
                  deleteImage(consultation.overviewImages[0].uuid);
                }
              }}
            >
              {t("summary.delete_image")}
            </button>
          </div>
        </div>
      </Modal>
      <div className="summary-header">
        <div className="back-header">
          <div className="back-wrapper">
            <button
              onClick={() => {
                navigate("/dashboard/consultations");
              }}
              className="back"
            />
            <h1>{t("case.summary")}</h1>
          </div>
          {status === "Complete" ? (
            <span
              data-title={`${t("case.status")}:`}
              className="status success"
            >
              {t("dashboard.state.complete")}
            </span>
          ) : (
            <span data-title={`${t("case.status")}:`} className="status">
              {status}
            </span>
          )}
        </div>
      </div>
      <div className="divider"></div>

      <div className="summary-container">
        {getTagline(
          consultation.appointment,
          consultation.category,
          consultation.diagnosed,
          consultation.rejected_by,
        )}

        {consultation &&
          doctor &&
          consultation.category === "picture" &&
          consultation.diagnosed === 1 &&
          consultation.rejected_by === null && (
            <Prescription
              consultation={consultation}
              doctor={doctor}
              diagnosis={consultation.diagnoses}
              feedbackButton={feedbackButton}
            />
          )}
        {consultation.diagnosed === 1 &&
          consultation.diagnoses &&
          consultation.diagnoses[0].next_appointment !== null &&
          (consultation.diagnoses[0].next_appointment_type !== null ? (
            <div className="next-appointment-video-wrapper">
              <div className="next-app-video-container">
                {t("summary.doctor_recommends_another_appointment")}{" "}
                <div className="app-date-container">
                  {moment(consultation.diagnoses[0].next_appointment).format(
                    "DD-MM-yyyy",
                  )}
                  <img src={calendar} alt="calendar" />
                </div>
                via{" "}
                <span>{consultation.diagnoses[0].next_appointment_type}</span>
                {t("summary.consultation")}
              </div>
              {!hasDatePassed(consultation.diagnoses[0].next_appointment) && (
                <div className="btn-container">
                  <button
                    className="book-now-btn"
                    onClick={() => handleBookNow()}
                  >
                    {t("summary.book_now")}
                  </button>

                  <div
                    onClick={() => addReminder(consultation.diagnoses[0].uuid)}
                    className="remind-btn"
                  >
                    {(consultation.diagnoses[0].appointment_reminder === 0 ||
                      consultation.diagnoses[0].appointment_reminder ===
                        false) && <img src={bell} alt="bell" />}
                    {consultation.diagnoses[0].appointment_reminder === 0 ||
                    consultation.diagnoses[0].appointment_reminder === false ? (
                      <span>{t("summary.remind_me")}</span>
                    ) : (
                      <span>{t("summary.reminder_set")}!</span>
                    )}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="next-appointment-video-wrapper">
              <div className="next-app-video-container">
                {t("summary.doctor_recommends_another_appointment")}{" "}
                <div className="app-date-container">
                  {moment(consultation.diagnoses[0].next_appointment).format(
                    "DD-MM-yyyy",
                  )}
                  <img src={calendar} alt="calendar" />
                </div>
              </div>
              {!hasDatePassed(consultation.diagnoses[0].next_appointment) && (
                <div className="btn-container">
                  {isLessThan24Hours(
                    consultation.diagnoses[0].next_appointment,
                  ) && (
                    <button
                      className="book-now-btn"
                      onClick={() => handleBookNow()}
                    >
                      {t("summary.book_now")}
                    </button>
                  )}
                  <div
                    onClick={() => addReminder(consultation.diagnoses[0].uuid)}
                    className="remind-btn"
                  >
                    {(consultation.diagnoses[0].appointment_reminder === 0 ||
                      consultation.diagnoses[0].appointment_reminder ===
                        false) && <img src={bell} alt="bell" />}
                    {consultation.diagnoses[0].appointment_reminder === 0 ||
                    consultation.diagnoses[0].appointment_reminder === false ? (
                      <span>{t("summary.remind_me")}</span>
                    ) : (
                      <span>{t("summary.reminder_set")}!</span>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}

        {consultation.referrals &&
          consultation.referrals.map((referal) => (
            <DownloadFile
              fileName={referal.name}
              suffix={referal.suffix}
              uuid={referal.uuid}
            />
          ))}

        {/* {consultation.category === "picture" &&
          consultation.diagnosed === 1 && (
            <span className="unhappy-diagnosis-text">
              Unhappy with your diagnosis? Tell us what went wrong
            </span>
          )}
        {consultation.category === "video" &&
          getDays(consultation.appointment) < 0 && (
            <span className="unhappy-diagnosis-text">
              Unhappy with your diagnosis? Tell us what went wrong
            </span>
          )} */}

        {/* <div className="divider"></div> */}
        <AccordionItem
          title={t("summary.show_case_history")}
          isOpen={accordionIsOpen}
          onClick={() => setAccordionIsOpen(!accordionIsOpen)}
          className="case-history-accordion"
        >
          {consultation.category === "picture" ? (
            <div className="history-div">
              <div className="history-item">
                <span className="history-heading">
                  {t("case_history.duration")}
                </span>
                <span className="history-value">{consultation.duration}</span>
              </div>
              <div className="history-item">
                <span className="history-heading">
                  {t("case_history.body_part")}
                </span>
                <span className="history-value">
                  {JSON.parse(consultation.body_part).join(",")}
                </span>
              </div>
              <div className="history-item">
                <span className="history-heading">
                  {t("case_history.problems")}
                </span>

                <span className="history-value">
                  {JSON.parse(consultation.description).join(",")}
                </span>
              </div>
              <div className="history-item">
                <span className="history-heading">
                  {t("case_history.detail_description")}
                </span>
                <span className="history-value">
                  {JSON.parse(consultation.detail_description ?? "------")}
                </span>
              </div>
              <div className="history-item">
                <span className="history-heading">
                  {t("case_history.allergies")}
                </span>
                <span className="history-value">
                  {consultation.allergy_description ?? "------"}
                </span>
              </div>
              <div className="history-item">
                <span className="history-heading">
                  {t("case_history.medicines")}
                </span>
                <span className="history-value">
                  {consultation.medication === "yes"
                    ? consultation.medication_description
                    : "------"}
                </span>
              </div>
              <div className="history-item">
                <span className="history-heading">
                  {t("case_history.past_treatment")}
                </span>
                <span className="history-value">
                  {!consultation.treatment
                    ? "------"
                    : consultation.treatment_description}
                </span>
              </div>
              <div className="history-item">
                <span className="history-heading">
                  {t("case_history.family_history")}
                </span>
                <span className="history-value">
                  {!consultation.family_history
                    ? "------"
                    : consultation.family_history_description}
                </span>
              </div>
              <div className="history-images-container">
                {consultation.closeupImages.map((imgObj) => {
                  return imgObj.is_visible === 0 ? (
                    <div className="history-image-deleted">
                      <div className="image-unavailable-wrapper">
                        <img
                          src={imgUnavailable}
                          alt="closeup unavailable"
                          className="delete-icon"
                        />

                        <span className="deleted-text">Image unavailable</span>
                      </div>
                    </div>
                  ) : (
                    <div className="history-image">
                      <img src={imgObj.url} alt="history" />
                      {consultation.diagnosed === 1 && (
                        <div
                          onClick={() => {
                            setIsCloseup(1);
                            openModal();
                          }}
                          className="delete-icon-wrapper"
                        >
                          <img
                            src={deleteIcon}
                            alt="delete"
                            className="delete-icon"
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
                {consultation.overviewImages.map((imgObj) => {
                  return imgObj.is_visible === 0 ? (
                    <div className="history-image-deleted">
                      <div className="image-unavailable-wrapper">
                        <img
                          src={imgUnavailable}
                          alt="overview unavailable"
                          className="delete-icon"
                        />
                        <span className="deleted-text">Image unavailable</span>
                      </div>
                    </div>
                  ) : (
                    <div className="history-image">
                      <img src={imgObj.url} alt="history" />

                      {consultation.diagnosed === 1 && (
                        <div
                          onClick={() => {
                            setIsCloseup(0);
                            openModal();
                          }}
                          className="delete-icon-wrapper"
                        >
                          <img
                            src={deleteIcon}
                            alt="delete"
                            className="delete-icon"
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="history-div">
              <div className="history-item">
                <span className="history-heading">
                  {t("case_history.detail_description")}
                </span>
                <span className="history-value">
                  {JSON.parse(consultation.description) ?? "------"}
                </span>
              </div>
            </div>
          )}
        </AccordionItem>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    consultation: state.diagnoses.selectedConsultation,
    doctors: state.diagnoses.doctors,
    file: state.diagnoses.file,
    diagnosis: state.diagnosis,
  };
}

export default connect(mapStateToProps, {
  getDiagnosisByUUID,
  getDoctor,
  setReminder,
  changeReminderState,
  removeCaseImage,
  changeImageVisibility,
})(withTranslation()(Summary));
